var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "width": "20",
      "height": "10",
      "viewBox": "0 0 20 10",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M5 10C3.61667 10 2.43767 9.51233 1.463 8.537C0.488334 7.56167 0.000667349 6.38267 6.82594e-07 5C-0.000665984 3.61733 0.487001 2.43833 1.463 1.463C2.439 0.487667 3.618 0 5 0H8C8.28333 0 8.521 0.0960001 8.713 0.288C8.905 0.48 9.00067 0.717333 9 1C8.99933 1.28267 8.90333 1.52033 8.712 1.713C8.52067 1.90567 8.28333 2.00133 8 2H5C4.16667 2 3.45833 2.29167 2.875 2.875C2.29167 3.45833 2 4.16667 2 5C2 5.83333 2.29167 6.54167 2.875 7.125C3.45833 7.70833 4.16667 8 5 8H8C8.28333 8 8.521 8.096 8.713 8.288C8.905 8.48 9.00067 8.71733 9 9C8.99933 9.28267 8.90333 9.52033 8.712 9.713C8.52067 9.90567 8.28333 10.0013 8 10H5ZM7 6C6.71667 6 6.47933 5.904 6.288 5.712C6.09667 5.52 6.00067 5.28267 6 5C5.99933 4.71733 6.09533 4.48 6.288 4.288C6.48067 4.096 6.718 4 7 4H13C13.2833 4 13.521 4.096 13.713 4.288C13.905 4.48 14.0007 4.71733 14 5C13.9993 5.28267 13.9033 5.52033 13.712 5.713C13.5207 5.90567 13.2833 6.00133 13 6H7ZM12 10C11.7167 10 11.4793 9.904 11.288 9.712C11.0967 9.52 11.0007 9.28267 11 9C10.9993 8.71733 11.0953 8.48 11.288 8.288C11.4807 8.096 11.718 8 12 8H15C15.8333 8 16.5417 7.70833 17.125 7.125C17.7083 6.54167 18 5.83333 18 5C18 4.16667 17.7083 3.45833 17.125 2.875C16.5417 2.29167 15.8333 2 15 2H12C11.7167 2 11.4793 1.904 11.288 1.712C11.0967 1.52 11.0007 1.28267 11 1C10.9993 0.717333 11.0953 0.48 11.288 0.288C11.4807 0.0960001 11.718 0 12 0H15C16.3833 0 17.5627 0.487667 18.538 1.463C19.5133 2.43833 20.0007 3.61733 20 5C19.9993 6.38267 19.5117 7.562 18.537 8.538C17.5623 9.514 16.3833 10.0013 15 10H12Z",
      "fill": "black"
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }